import { isArray } from '@atds-legacy/lang';
import { Resource } from '@redge-media/fo-js-sdk';
import Episode from './episode';

const Episodes = Resource.extend({
  endpoint: '/products/vods',
  recordClass: Episode,

  constructor: function Episodes(opts = {}) {
    Resource.call(this);

    this.collection.comparator = (a, b) => a.episode - b.episode;
    if (opts.sortType === 'DESC') {
      this.collection.comparator = (a, b) => b.episode - a.episode;
    }

    this.season = undefined;
  },

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize.call(this, response, opts);

    if (isArray(data) && this.season) {
      data.forEach((e) => {
        e.season = this.season;
      });
    }

    return data;
  },

  getPath(method, opts) {
    if (method === 'fetch') {
      return `${this.endpoint}/${opts.id}`;
    }

    if (method === 'fetchAll') {
      return `${this.endpoint}/serials/${opts.serialId}/seasons/${opts.seasonId}/episodes`;
    }

    return undefined;
  },
});

export default Episodes;
